var poll_header_default = {
  "title": "EJA-0",
  "image": "JaQkT",
  "webview": "_2fAWz"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
